import axios, { Axios, AxiosError } from 'axios';
import { API_URL } from '../config';
import { Fields } from "../types";
import { AxiosRequestConfig } from 'axios';

interface CustomAxiosRequestConfig extends AxiosRequestConfig {
  permission?: string;
}


// login call
export const login = async (data: any) => {

  let body = {
    codice_azienda: parseInt(data.codice),
    email: data.email,
    password: data.password,
    debug: false
  }

  if (import.meta.env.VITE_APP_ENV === 'development') {
    body = {
      ...body,
      // debug: true
    }
  }

  const response = await axios.post(`${API_URL}/login`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  return response.data;
}

export const whoami = async (token: string) => {
  const response = await axios.get(`${API_URL}/me`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const singupFields = async (): Promise<Fields> => {
  try {
    const response = await axios.get<Fields>(`${API_URL}/signup?ajax=1`);

    return response.data;
  } catch (e) {
    const error = e as AxiosError;
    throw new Error(`Error in 'singupFields': ${error.message}`);
  }
};


type SignupResponseSuccess = {
  success: boolean;
}

export type SignupResponseError = {
  error: any;
}

export const singup = async (data: Record<string, any>): Promise<SignupResponseSuccess> => {
  const response = await axios.post(
    `${API_URL}/signup?ajax=1`,
    data,
  );

  return response.data;
};

export const singupShort = async (data: Record<string, any>): Promise<SignupResponseSuccess> => {
  console.log(data);
  
  const response = await axios.post(
    `${API_URL}/signup-short`,
    data,
  );

  return response.data;
};


export const fetchEmployees = async (token: string, q: string | null = null, signal: AbortSignal | null = null, permission: string | null) => {
  const config: any = {};

  if(signal !== null)
    config.signal = signal;

  if(q !== null)
    config.params = {q};

  if (permission) 
    config.permission = permission;
  
  const response = await axios.get(`${API_URL}/dipendenti`, {
    headers: {
      'Authorization': `${token}`,
    },
    ...config
  })
  return response.data;
}

export const fetchBuste = async (token: string, employee: any, permission: string | null) => {
  const response = await axios.get(`${API_URL}/buste_paga${employee != false ? ('?employee=' + employee) : ''}`, {
    headers: {
      'Authorization': `${token}`,
    },
    permission,
  } as CustomAxiosRequestConfig);
  return response.data;
}

export const fetchCu = async (token: string, employee: any, permission: string | null) => {
  const response = await axios.get(`${API_URL}/cu${employee != false ? ('?employee=' + employee) : ''}`, {
    headers: {
      'Authorization': `${token}`,
    },
    permission,
  } as CustomAxiosRequestConfig);
  return response.data;
}

export const fetchDocs = async (token: string, employee: any, permission: string | null) => {
  const response = await axios.get(`${API_URL}/documenti`, {
    headers: {
      'Authorization': `${token}`,
    },
    permission,
  } as CustomAxiosRequestConfig);
  return response.data;
}



export const fetchCuDetail = async (token: string, id: any) => {
  const response = await axios.get(`${API_URL}/cu/${id}`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const deleteCu = async (token: string, id: any) => {
  const response = await axios.delete(`${API_URL}/cu/${id}`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const fetchBusta = async (token: string, id: any) => {
  const response = await axios.get(`${API_URL}/buste_paga/${id}`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const deleteBusta = async (token: string, id: any) => {
  const response = await axios.delete(`${API_URL}/buste_paga/${id}`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const fetchDoc = async (token: string, id: any) => {
  const response = await axios.get(`${API_URL}/documenti/${id}`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const deleteDoc = async (token: string, id: any) => {
  const response = await axios.delete(`${API_URL}/documenti/${id}`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}

export const updateDocVisibility = async (token: string, id: any, visibleToEmployee: boolean) => {
  const response = await axios.patch(`${API_URL}/documenti/${id}`, {
    visible_to_employee: visibleToEmployee,
  }, {
    headers: {
      'Authorization': `${token}`,
    }
  });
  return response.data;
}

export const fetchEmployee = async (token: string, employee: any, permission: string | null) => {
  const config: any = {};

  if (permission) 
    config.permission = permission;

  const response = await axios.get(`${API_URL}/dipendenti/${employee}`, {
    headers: {
      'Authorization': `${token}`,
    },
    ...config
  })
  return response.data;
}


export const uploadBustePagaMassive = async (token: string, data: any ) => {
  const response = await axios.post(`${API_URL}/upload_massivo/bp`, data, {
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'multipart/form-data',
    }
  })
  return response.data;
}

export const uploadBustePagaSingolo = async (token: string, data: any) => {
  const response = await axios.post(`${API_URL}/buste_paga/upload`, data, {
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'multipart/form-data',
    }
  })
  return response.data;
}

export const uploadCuSingolo = async (token: string, data: any) => {
  const response = await axios.post(`${API_URL}/cu/upload`, data, {
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'multipart/form-data',
    }
  })
  return response.data;
}

export const uploadDocumentiSingolo = async (token: string, data: any) => {
  const response = await axios.post(`${API_URL}/documenti/upload`, data, {
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'multipart/form-data',
    }
  })
  return response.data;
}


export const uploadCuMassive = async (token: string, data: any ) => {
  const response = await axios.post(`${API_URL}/upload_massivo/cu`, data, {
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'multipart/form-data',
    }
  })
  return response.data;
}

export const downloadReportCedolini = async (token: string, anno: any, mese: any) => {
  const response = await axios.get(`${API_URL}/report_buste_paga/${anno}/${mese}`, {
    headers: {
      'Authorization': `${token}`,
    },
    responseType: 'blob', // Ensure a Blob will be returned
  });
  
  if (response.status !== 200) {
    throw new Error(`Error status code: ${response.status}`);
  }

  const fileBlob: Blob = new Blob([response.data], { type: 'application/pdf' });

  return fileBlob;
  
};

export const downloadReportCedoliniV2 = async (token: string, anno: any, mese: any) => {
  const response = await axios.get(`${API_URL}/report_buste_paga/${anno}/${mese}/v2`, {
    headers: {
      'Authorization': `${token}`,
    },
    responseType: 'blob', // Ensure a Blob will be returned
  });
  
  if (response.status !== 200) {
    throw new Error(`Error status code: ${response.status}`);
  }

  const fileBlob: Blob = new Blob([response.data], { type: 'application/pdf' });

  return fileBlob;
  
};

export const downloadReportCu = async (token: string, anno: any) => {
  const response = await axios.get(`${API_URL}/report_certificazioni_uniche/${anno}`, {
    headers: {
      'Authorization': `${token}`,
    },
    responseType: 'blob', // Ensure a Blob will be returned
  });
  
  if (response.status !== 200) {
    throw new Error(`Error status code: ${response.status}`);
  }

  const fileBlob: Blob = new Blob([response.data], { type: 'application/pdf' });

  return fileBlob;
  
};

export const downloadReportCuV2 = async (token: string, anno: any) => {
  const response = await axios.get(`${API_URL}/report_certificazioni_uniche/${anno}/v2`, {
    headers: {
      'Authorization': `${token}`,
    },
    responseType: 'blob', // Ensure a Blob will be returned
  });
  
  if (response.status !== 200) {
    throw new Error(`Error status code: ${response.status}`);
  }

  const fileBlob: Blob = new Blob([response.data], { type: 'application/pdf' });

  return fileBlob;
  
};


export const createDipendente = async (token: string, data: any) => {
  // values = {first_name: 'dasd', last_name: 'asd', tax_code: 'asdas', email: 'asdasd'}
  const response = await axios.post(`${API_URL}/dipendenti`, data, {
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'multipart/form-data',
    }
  })
  return response.data;
}

export const createDipendenteByUnilav = async (token: string, data: any) => {
  // values = {first_name: 'dasd', last_name: 'asd', tax_code: 'asdas', email: 'asdasd'}
  const response = await axios.post(`${API_URL}/dipendenti/unilav/create`, data, {
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'multipart/form-data',
    }
  })
  return response.data;
}

export const bulkCreateEmployees = async (token: string, data: any) => {
  const response = await axios.post(`${API_URL}/dipendenti/bulk-create/`, data, {
    headers: {
      'Authorization': `${token}`,
    },
  });
  return response.data;
};


export const updateDipendente = async (token: string, data: any) => {
  // values = {first_name: 'dasd', last_name: 'asd', tax_code: 'asdas', email: 'asdasd'}
  const response = await axios.post(`${API_URL}/dipendenti/${data.cf}`, data, {
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'multipart/form-data',
    }
  })
  return response.data;
}


export const deleteDipendente = async (token: string, cf: string) => {
  const response = await axios.delete(`${API_URL}/dipendenti/${cf}/delete`, {
    headers: {
      'Authorization': `${token}`,
    }
  })
  return response.data;
}


export const reassignDoc = async (token: string, doc_id: number, doc_type: string,  employee_cf: string) => {
  // values = {first_name: 'dasd', last_name: 'asd', tax_code: 'asdas', email: 'asdasd'}
  const response = await axios.post(`${API_URL}/docs/${doc_type}/${doc_id}/reassign`, {employee_cf}, {
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'multipart/form-data',
    }
  })
  return response.data;
}


export const confirmEmpDoc = async (token: string, doc_id: number, doc_type: string) => {
  const response = await axios.post(`${API_URL}/docs/${doc_type}/${doc_id}/confirm`, {}, {
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'multipart/form-data',
    }
  })
  return response.data;
}

export const deleteEmpDoc = async (token: string, doc_id: number, doc_type: string) => {
  const response = await axios.post(`${API_URL}/docs/${doc_type}/${doc_id}/delete`, {}, {
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'multipart/form-data',
    }
  })
  return response.data;
}

export const confirmAllEmpDocs = async (token: string, docs_id: number[], doc_type: string) => {
  const response = await axios.post(`${API_URL}/docs/${doc_type}/confirmall`, {ids: docs_id}, {
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'multipart/form-data',
    }
  })
  return response.data;
}

export const deleteAllEmpDocs = async (token: string, docs_id: number[], doc_type: string) => {
  const response = await axios.post(`${API_URL}/docs/${doc_type}/deleteall`, {ids: docs_id}, {
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'multipart/form-data',
    }
  })
  return response.data;
}


// export const updateDipendente = async (token: string, data: any, employee: any) => {
//   // values = {first_name: 'dasd', last_name: 'asd', tax_code: 'asdas', email: 'asdasd'}
//   const response = await axios.put(`${API_URL}/dipendenti/${employee}`, data, {
//     headers: {
//       'Authorization': `${token}`
//     }
//   })
//   return response.data;
// }

export const resetDipendentePassword = async (token: string, id: any) => {
  // values = {first_name: 'dasd', last_name: 'asd', tax_code: 'asdas', email: 'asdasd'}
  const response = await axios.post(`${API_URL}/dipendenti/${id}/reset_password`, {}, {
    headers: {
      'Authorization': `${token}`
    }
  })
  return response.data;
}

export const changeAppEnable = async (token: string, id: any, status: string) => {
  const response = await axios.post(`${API_URL}/dipendenti/${id}/app/${status}`, {}, {
    headers: {
      'Authorization': `${token}`
    }
  })
  return response.data;
}

export const getLivelli = async (token: string) => {
  const response = await axios.get(`${API_URL}/livelli`, {
    headers: {
      'Authorization': `${token}`,
    }
  });

  return response.data;
}

export const selezionaLivello = async (token: string, plan_id: string, qnt: number, coupon?: string) => {
  const params = new URLSearchParams({
    pk: plan_id,
    qnt: qnt.toString()
  });

  if (typeof coupon === 'string' && coupon.trim() !== '') {
    params.append('coupon', coupon);
  }

  try {
    const response = await axios.get(`${API_URL}/livelli/selezione?${params.toString()}`, {
      headers: {
        'Authorization': `${token}`,
      }
    });

    return response.data;
  } catch (error) {
    console.error('Errore nella selezione del livello:', error);
    throw error;
  }
};

export const cancellaLivello = async (token: string, level_id: number) => {
  const response = await axios.delete(`${API_URL}/livelli/cancella/${level_id}`, {
    headers: {
      'Authorization': `${token}`,
    }
  });

  return response.data;
}

export const getPaymentInfo = async (token: string) => {

  const response = await axios.get(`${API_URL}/profile/payment-info`, {
    headers: {
      'Authorization': `${token}`,
    }
  });
  // Return the search results
  return response.data;
};

export const setPaymentInfo = async (token: string, data: string) => {

  const response = await axios.post(`${API_URL}/profile/payment-info`, data,
  {
    headers: {
      'Authorization': `${token}`,
    }
  });
  // Return the search results
  return response.data;
};


export const recover = async (data: Record<string, any>) => {
  const body: Record<string, any> = data

  if (import.meta.env.VITE_APP_ENV === 'development') {
    body['debug'] = true
  }

  const response = await axios.post(`${API_URL}/recover`, body, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  return response.data;
}

export const changePassword = async (token: string, data: any) => {
  // profile/change_password
  const response = await axios.post(`${API_URL}/profile/change_password`, data, {
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'multipart/form-data',
    }
  });

  return response.data;
}

export const updateProfile = async (token: string, data: any) => {
  // values = {first_name: 'dasd', last_name: 'asd', tax_code: 'asdas', email: 'asdasd'}
  const response = await axios.post(`${API_URL}/profile`, data, {
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'multipart/form-data',
    }
  })
  return response.data;
}

export const getProfile = async (token: string) => {
  const response = await axios.get(`${API_URL}/profile`, {
    headers: {
      'Authorization': `${token}`,
    }
  });

  return response.data;
}

/**
 * Function to fetch consulenti data based on the input value.
 * @param {string} inputValue - The input value to search for.
 * @param {string} token - authorizaion token.
 * @returns {Array} - Array of search results or null in case of error.
 */
export const fetchConsulenti = async (token:string, inputValue: string) => {
  // Create a new CancelToken
  const newSource = axios.CancelToken.source();

  // Making the API call
  const response = await axios.get(`${API_URL}/consulenti/search`, {
    params: { q: inputValue },
    headers: {
      'Authorization': `${token}`,
    },
    cancelToken: newSource.token
  });
  // Return the search results
  return response.data;
};

export const assignConsulente = async (token: string, consulente_id: string) => {
  // Create a new CancelToken
  // Making the API call
  const response = await axios.post(`${API_URL}/consulenti`, {
    c_id: consulente_id
  }, {
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'multipart/form-data',
    }
  });
  // Return the search results
  return response.data;
};

export const getConsulenti = async (token: string) => {
  // Create a new CancelToken
  // Making the API call
  const response = await axios.get(`${API_URL}/consulenti`, {
    headers: {
      'Authorization': `${token}`,
    }
  });
  // Return the search results
  return response.data;
};

export const deleteConsulente = async (token: string, consulente_id: string) => {
  // Create a new CancelToken
  // Making the API call
  const response = await axios.post(`${API_URL}/consulenti/${consulente_id}/delete`, {
    c_id: consulente_id
  }, {
    headers: {
      'Authorization': `${token}`,
      'Content-Type': 'multipart/form-data',
    }
  });
  // Return the search results
  return response.data;
};


export const getBillingData = async (token: string) => {

  const response = await axios.get(`${API_URL}/profile/billing`, {
    headers: {
      'Authorization': `${token}`,
    }
  });
  // Return the search results
  return response.data;
};

export const setBillingData = async (token: string, data: any) => {

  const response = await axios.put(`${API_URL}/profile/billing`, data,
  {
    headers: {
      'Authorization': `${token}`,
    }
  });
  // Return the search results
  return response.data;
};



export const sendCredentialEmployee = async (token: string, id: string) => {
  const response = await axios.get(`${API_URL}/dipendenti/${id}/send-credential/`, {
    headers: {
      'Authorization': `${token}`,
    },
  });
  return response.data;
};


// export const createTimeSlot = async (token: string, body: any) => {
//   const response = await axios.post(`${API_URL}/presenze/company/time-slots/`, body,
//     {
//       headers: {
//         'Authorization': `${token}`,
//       }
//     });
//   // Return the search results
//   return response.data;
// }

// export const createBreak = async (token: string, body: any) => {
//   const response = await axios.post(`${API_URL}/presenze/company/breaks/`, body,
//     {
//       headers: {
//         'Authorization': `${token}`,
//       }
//     });
//   // Return the search results
//   return response.data;
// }